import get from 'lodash/get';
import React, { memo } from 'react';

import { Tabs } from '@sravni/react-design-system';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import type ITabDetail from '../../interfaces/ITabDetail';

import Table from './components/Table';

interface IProps {
  className?: string;
  config?: ITabDetail;
  product: IProduct;
  isProductPage?: boolean;
}

const DynamicProductTable: React.FC<IProps> = memo((props: IProps) => {
  const {
    product,
    config: { dynamicTable, additionalInformation },
  } = props;

  return (
    <Tabs>
      {Object.entries(get(product, dynamicTable.tabs)).map(([key, value]) => (
        <Tabs.TabPane title={key} key={key}>
          <Table
            {...props}
            product={value as IProduct}
            additionalInformation={additionalInformation ? product[additionalInformation.property] : null}
          />
        </Tabs.TabPane>
      ))}
    </Tabs>
  );
});

export default DynamicProductTable;
